export var ProductDataAccess;
(function (ProductDataAccess) {
    ProductDataAccess[ProductDataAccess["HideAllDesignData"] = 0] = "HideAllDesignData";
    ProductDataAccess[ProductDataAccess["HideModelReports"] = 1] = "HideModelReports";
    ProductDataAccess[ProductDataAccess["ShowAllData"] = 2] = "ShowAllData";
})(ProductDataAccess || (ProductDataAccess = {}));
export var ProjectDataAccess;
(function (ProjectDataAccess) {
    ProjectDataAccess[ProjectDataAccess["HideProjectSource"] = 0] = "HideProjectSource";
    ProjectDataAccess[ProjectDataAccess["ShowAllData"] = 1] = "ShowAllData";
})(ProjectDataAccess || (ProjectDataAccess = {}));
